"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var subscription_1 = require("../../../api/subscription");
var EditLicenseButton = function (props) {
    var className = props.className;
    var _a = (0, react_1.useState)({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = (0, react_1.useState)(0), companyId = _b[0], setCompanyId = _b[1];
    var _c = (0, react_1.useState)({ id: 0, name: "", unit: "", companyId: "", licenseId: "" }), licenseData = _c[0], setLicenseData = _c[1];
    var _d = (0, react_1.useState)(false), modal = _d[0], setModal = _d[1];
    var toggle = function () { return setModal(!modal); };
    var submitUpdateLicense = function () {
        var obj = {
            companyId: licenseData.companyId,
            purchasedLicenseId: licenseData.id,
            licenseId: licenseData.licenseId,
            //name: licenseData.name,
            unit: licenseData.unit,
            userId: graphData,
        };
        (0, subscription_1.updatePurchasedLicense)(props.id, obj).then(function (response) {
            props.modalCallback(response);
        });
        toggle();
    };
    //useImperativeHandle(ref, () => ({
    //    submitLicenseForm() {
    //        submitUpdateLicense();
    //    }
    //}));
    var onLoad = function () {
        var id = 1;
        if (props.id) {
            setCompanyId(props.id);
        }
        if (licenseData.id == 0 && props.list != null && props.list.length > 0)
            setLicenseData(props.list.reduce(function (acc, item) { if (props.id == item.id)
                acc = item; return acc; }, { id: 0 }));
        setGraphData(props.userId);
        /*console.log(graphData);*/
        /*console.log(licenseData);*/
    };
    var setFormChange = function (e, field) {
        var newLicenseData = licenseData;
        newLicenseData[field] = e.target.value;
        console.log(newLicenseData[field]);
        setLicenseData(__assign({}, newLicenseData));
    };
    //useEffect(() => {
    //    if (!isLoaded && inProgress === InteractionStatus.None) {
    //        onLoad();
    //    }
    //}, [instance, inProgress, licenseData, setLicenseData]);
    (0, react_1.useEffect)(function () {
        onLoad();
    }, [licenseData, setLicenseData]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" },
                React.createElement("img", { src: "./edit.svg", className: "font-icon" }))),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Edit License"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "name", id: "name", placeholder: licenseData.name, readOnly: true }))),
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Unit" }, "Unit"),
                                React.createElement(reactstrap_1.Input, { type: "number", name: "Unit", id: "Unit", placeholder: licenseData.unit, onChange: function (e) { return setFormChange(e, 'unit'); } })))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitUpdateLicense(); } }, "Confirm")))));
};
exports.default = EditLicenseButton;
//# sourceMappingURL=EditLicenseButton.js.map